import YFormProductQuickView from './ProductQuickView';

export { YFormProductQuickView };
export default YFormProductQuickView;
